import React from "react";
import "./Company.css";

const facts = [
  { label: "Founded", value: "2022" },
  { label: "Headquarters", value: "New York, NY" },
  { label: "Partner status", value: "AWS Select Consulting Partner" },
  { label: "Focus", value: "Startups & growing businesses" },
  { label: "Compliance", value: "SOC2 · HIPAA" },
];

const Company = () => {
  return (
    <section id="company" className="section">
      <div className="container company-grid">
        <div className="company-copy">
          <p className="eyebrow">who we are</p>
          <h2 className="h2">Building the future of cloud infrastructure</h2>
          <p className="company-highlight">
            We help startups and growing businesses harness the full power of
            AWS cloud without the complexity and overhead.
          </p>
          <p>
            With over a decade of combined AWS expertise, we've helped dozens
            of companies scale their cloud infrastructure while keeping costs
            under control. Our team of certified AWS experts brings
            enterprise-grade cloud management practices to growing businesses.
          </p>
          <p>
            Whether you're launching a new product, scaling your
            infrastructure, or optimizing costs, we provide the expertise you
            need to succeed in the cloud. Our hands-on approach means you get
            practical solutions, not just theoretical advice.
          </p>
        </div>
        <aside className="company-facts card">
          <div className="company-facts-title">tysonworks --info</div>
          {facts.map((fact) => (
            <div className="company-fact" key={fact.label}>
              <span>{fact.label}</span>
              <strong>{fact.value}</strong>
            </div>
          ))}
        </aside>
      </div>
    </section>
  );
};

export default Company;
